import AbstractApi from '@/api/abstracts/AbstractApi'
import CostingsHistoryApi from '@/api/services/sales/bid/cost/history/CostingsHistoryApi'
import httpClient from '@/utilities/service/httpClient'
// types
import { BidNumber } from '@/api/types/general/GeneralType'
import { CostingsType } from '@/api/types/response/CostingsType'
import { ApiResponseType } from '@/api/types/response/ApiResponseType'
import { SubmitCostingsPayloadType } from '@/api/types/request/SubmitCostingsPayloadType'

/**
 * @property string apiEnd /api/sales/bid/cost
 */
export default class CostingsApi extends AbstractApi {
  fetch(payload: string): Promise<CostingsType> {
    return httpClient.get(`${this.apiEnd}/${payload}`)
  }

  submit(bidNumber: BidNumber, payload: SubmitCostingsPayloadType): Promise<ApiResponseType<{ data: { message: string } }>> {
    return httpClient.post(`${this.apiEnd}/${bidNumber}`, payload)
  }

  history(bidNumber: BidNumber): CostingsHistoryApi {
    return new CostingsHistoryApi(`${this.apiEnd}/history/${bidNumber}`)
  }
}
